"use client";

import { UserColumn } from "@/types/extendedTable";

const columns: readonly UserColumn[] = [
  {
    id: "studentNumber",
    numeric: false,
    label: "Student Number",
  },
  {
    id: "fullName",
    numeric: false,
    label: "Name",
  },
  {
    id: "username",
    numeric: false,
    label: "Username",
  },
  {
    id: "birthdate",
    numeric: false,
    label: "Birthday",
  },
  {
    id: "zip",
    numeric: false,
    label: "Zip Code",
  },
];

export default columns;
